const PortalFooterPaymentLogo = (props) => (
  <svg viewBox="0 0 1000 323.7" {...props}>
    <style>{".a{fill:#C8C8C8;}"}</style>
    <g transform="matrix(4.43 0 0 4.43 -81.166 -105.05)">
      <polygon points="116.1 95.7 97.9 95.7 109.3 25 127.6 25" className="a" />
      <path
        d="m182.4 26.7c-3.6-1.4-9.3-3-16.4-3-18.1 0-30.8 9.6-30.9 23.4-0.1 10.2 9.1 15.8 16 19.2 7.1 3.5 9.5 5.7 9.5 8.8-0.1 4.7-5.7 6.9-11 6.9-7.3 0-11.2-1.1-17.2-3.8l-2.4-1.1-2.6 15.9c4.3 2 12.2 3.7 20.4 3.8 19.2 0 31.7-9.5 31.8-24.2 0.1-8.1-4.8-14.2-15.3-19.3-6.4-3.2-10.3-5.4-10.3-8.7 0.1-3 3.3-6.1 10.5-6.1 5.9-0.2 10.3 1.3 13.6 2.7l1.7 0.8 2.5-15.3z"
        className="a"
      />
      <path
        d="m206.7 70.7c1.5-4.1 7.3-19.8 7.3-19.8-0.1 0.2 1.5-4.1 2.4-6.8l1.3 6.1s3.5 16.9 4.2 20.5h-15.2zm22.6-45.7h-14.1c-4.4 0-7.7 1.3-9.6 5.9l-27.2 64.9h19.2s3.2-8.7 3.8-10.6h23.5c0.5 2.5 2.2 10.6 2.2 10.6h16.9l-14.8-70.7z"
        className="a"
      />
      <path
        d="m82.6 25-17.9 48.2-2-9.8c-3.3-11.3-13.7-23.5-25.3-29.6l16.4 61.8h19.3l28.7-70.6h-19.3z"
        className="a"
      />
      <path
        d="m48 25h-29.4l-0.3 1.4c23 5.9 38.2 20 44.4 37l-6.4-32.5c-1.1-4.5-4.3-5.8-8.3-5.9z"
        fill="#B4B4B4"
      />
    </g>
  </svg>
);

export default PortalFooterPaymentLogo;
